import request from "../../service/httpService";
import { updateField, getField } from "vuex-map-fields";

export default {
    namespaced: true,
    state() {
        return {
            storage: {},
        }
    },
    mutations: {
        updateField,
        setStorage(state, payload) {
            state.storage = payload;
        }
    },
    getters: {
        getField,
        storage: state => state.storage,
    },
    actions: {
        async fetch({ commit }) {
            //const id = rootGetters['profile/id'];
            const response = await request('get', 'me', ``,
                {
                    populate: 'storage,storage.storageType,storage.ingredients,storage.ingredients.ingredient.labels'
                });
            //console.log(response);
            const ingredients = response.storage.reduce((acc, storage) => {
                storage.ingredients.map(i => {
                    if (typeof acc[i.ingredient.id] === 'undefined') {
                        acc[i.ingredient.id] = i;
                    } else {
                        acc[i.ingredient.id].value += i.value;
                    }
                }) 
                return acc;
            }, {});
           
            commit("setStorage", ingredients);
           
        },
    }
};